<p-card>
  <ng-template pTemplate="header">
    <div class="flex justify-content-start">
      <div class="ml-5 mt-1">
        <p-floatlabel variant="on">
          <p-select
            id="undeliverableYear"
            [options]="years"
            [(ngModel)]="undeliverableYear"
            data-testId="undeliverableYear"
            [disabled]="false"
            appendTo="body"
            (onChange)="changeYear()"></p-select>
          <label for="undeliverableYear">Year</label>
        </p-floatlabel>
      </div>
      <div class="mt-2 ml-5">
        <p-button
          class="mr-3 mt-3"
          label="Add Date"
          [raised]="true"
          icon="fa fa-plus"
          size="small"
          (click)="newUndeliverableDate()"
          data-testId="newUndeliverableDate"></p-button>
      </div>
    </div>
  </ng-template>
  <p-table [value]="undeliverableDates" dataKey="id" class="table-sm" [tableStyle]="{ 'min-width': '50rem', 'width': '50vw' }">
    <ng-template #header>
      <tr>
        <th>Date</th>
        <th>Active</th>
        <th>Last Action</th>
      </tr>
    </ng-template>
    <ng-template #body let-undeliverableDate let-ri="rowIndex">
      <tr>
        <td>
          {{ undeliverableDate.date }}
        </td>
        <td>
          <p-toggleswitch
            [(ngModel)]="undeliverableDate.isActive"
            (change)="tglUndeliverableDates(undeliverableDate)"
            attr.data-testid="tglUndeliverableDates{{ undeliverableDate.date }}"
            [disabled]="isDisabled(undeliverableDate.date)" />
        </td>
        <td>
          <app-audit-info [value]="undeliverableDate" [direction]="'horizontal'"></app-audit-info>
        </td>
      </tr>
    </ng-template>
  </p-table>
</p-card>

<p-dialog
  header="New Undeliverable Date"
  [modal]="true"
  [showHeader]="false"
  [position]="'center'"
  [closeOnEscape]="false"
  [closable]="false"
  [(visible)]="dialogVars.visible"
  [style]="{ width: '25rem' }"
  data-testid="newItemDialog"
  appendTo="body">
  <div class="mb-3" style="height: 20rem">
    <p-floatlabel class="mt-1" variant="on">
      <p-datepicker
        *ngIf="dialogVars.minDate && dialogVars.maxDate"
        id="date"
        [(ngModel)]="undeliverableDate.date"
        [minDate]="dialogVars.minDate"
        [maxDate]="dialogVars.maxDate"
        showIcon
        iconDisplay="input"
        data-testId="newItemSelect"
        appendTo="body"></p-datepicker>
      <label for="name">Date</label>
    </p-floatlabel>
  </div>

  <div class="flex justify-content-between gap-2">
    <p-button
      label="Cancel"
      icon="fa fa-times"
      severity="danger"
      size="small"
      [raised]="true"
      (click)="exitNewDateDlg()"
      data-testid="newItemCancel" />
    <p-button
      label="Save"
      icon="fa fa-check"
      severity="success"
      size="small"
      [raised]="true"
      (click)="saveNewDateDlg()"
      [disabled]="!isValidNewDataDlg()"
      data-testid="newItemSave" />
  </div>
</p-dialog>
